export default "__VITE_ASSET__c49b23f1__"